import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import util from "./assets/util";
import api from "./assets/api";

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import "./assets/less/index.less";
import 'iview/dist/styles/iview.css';

import { Message, Modal, Spin, Icon, Table, Page } from 'iview';
Vue.prototype.$Message = Message; //按需引入iview的Message组件
Vue.prototype.$Spin = Spin; //按需引入iview的Message组件
Vue.use(ElementUI);
Vue.component('Modal', Modal);
Vue.component('Icon', Icon);
Vue.component('Table', Table);
Vue.component('Page', Page);

Vue.config.productionTip = false

// 加载自定义插件
function installPlugin(plugin, name) {
    plugin.install = function() {
        Vue.prototype[name] = this;
    };
    Vue.use(plugin);
}

const vm = new Vue({});
installPlugin(vm, "$vm");
window.$vm = vm;

installPlugin(api, "$api"); //api注册到全局
installPlugin(util, "$util"); //公共函数注册到全局

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')